/* import __COLOCATED_TEMPLATE__ from './checking-balances.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { NEXT_PAGE_SIZE } from '@banking/api/services/banking-unit-account-pagination';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { CHECKING_CROSS_SELL_CLICK_EVENT } from '@banking/ui/utils/launchpad/event-catalog';
import assert from '@banking/ui/utils/assert';
import { linkClickEvent } from '@dashboard/junk-drawer/utils/eventstream';
import { Action, Target, Page, getEvent } from '@banking/ui/utils/launchpad-cdp-events';
import { CardFulfillment } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { TrackerStatus } from '@squareup/banking-shared-ui/card';
let CheckingBalances = (_class = class CheckingBalances extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "bankingUnitAccountPagination", _descriptor, this);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "events", _descriptor3, this);
    _initializerDefineProperty(this, "pageStart", _descriptor4, this);
    _initializerDefineProperty(this, "pageEnd", _descriptor5, this);
  }
  get isLoading() {
    return this.bankingUnitAccountPagination.isLoading;
  }
  get isPaginated() {
    return this.args.units.length > NEXT_PAGE_SIZE;
  }
  get paginatedBalances() {
    return this.args.balances.slice(this.pageStart, this.pageEnd);
  }
  get showCheckingCrossSell() {
    return this.args.balances.length === 1 && this.args.balances[0].type !== AccountType.CHECKING_ACCOUNT;
  }
  get trackableCardBalanceId() {
    return this.args.trackableCard?.balanceId || '';
  }
  get trackableCardName() {
    if (!this.args.trackableCard) {
      return '';
    }
    const lastFour = this.args.trackableCard.lastFour || '';
    // TODO(cvu): support different card brands once it's available in Card model
    return `Mastercard ${lastFour}`;
  }
  get trackableCardArrivalDate() {
    if (!this.args.trackableCard?.fulfillment?.deliveryDate) {
      return new Date();
    }
    const {
      year,
      monthOfYear,
      dayOfMonth
    } = this.args.trackableCard.fulfillment.deliveryDate;
    return new Date(year, monthOfYear - 1, dayOfMonth);
  }
  get trackableCardStatus() {
    if (this.args.trackableCard?.fulfillment?.status === CardFulfillment.FulfillmentStatus.FULFILLMENT_STATUS_SHIPPED) {
      return TrackerStatus.Shipped;
    }
    if (this.args.trackableCard?.fulfillment?.status === CardFulfillment.FulfillmentStatus.FULFILLMENT_STATUS_DELIVERED || this.args.trackableCard?.fulfillment?.deliveryDate && this.trackableCardArrivalDate <= new Date()) {
      return TrackerStatus.Delivered;
    }
    return TrackerStatus.Processing;
  }

  // This is needed for event tracking as they want specific values in CDP
  get statusStringForTrackerEvent() {
    switch (this.trackableCardStatus) {
      case TrackerStatus.Processing:
        return 'processing';
      case TrackerStatus.Shipped:
        return 'shipped';
      case TrackerStatus.Delivered:
        return 'delivered';
    }
  }
  onTrackerActivateCardClick(unitToken) {
    if (this.args.onTrackerActivateCardClick) {
      this.args.onTrackerActivateCardClick(unitToken);
    }
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.Click, {
        target: Target.DebitCardActivationTracker,
        cardStatus: this.statusStringForTrackerEvent
      })
    });
  }
  trackSavingsCrossSellClickEvent() {
    this.events.track({
      kind: 'EVENTSTREAM',
      event: linkClickEvent(CHECKING_CROSS_SELL_CLICK_EVENT)
    });
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.Click, {
        target: Target.CheckingXsell
      })
    });
  }
  onActivateDebitCardUpsellClick(unitToken) {
    assert(typeof unitToken === 'string');
    this.args.activateDebitCard(unitToken);
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.Click, {
        target: Target.ActivateDebitCard,
        page: Page.ActivationUpsell,
        unitToken
      })
    });
  }
  trackActivateDebitCardUpsellView(unitToken) {
    assert(typeof unitToken === 'string');
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.View, {
        page: Page.ActivationUpsell,
        unitToken
      })
    });
  }
  onDebitCardTrackerViewed() {
    this.events.track({
      kind: 'CDP',
      event: getEvent(Action.View, {
        target: Target.DebitCardActivationTracker,
        cardStatus: this.statusStringForTrackerEvent
      })
    });
  }
  refreshAccounts() {
    this.bankingAccountApi.reloadAccounts();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingUnitAccountPagination", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "events", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pageStart", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pageEnd", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return NEXT_PAGE_SIZE;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onTrackerActivateCardClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTrackerActivateCardClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackSavingsCrossSellClickEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackSavingsCrossSellClickEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onActivateDebitCardUpsellClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onActivateDebitCardUpsellClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackActivateDebitCardUpsellView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackActivateDebitCardUpsellView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDebitCardTrackerViewed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDebitCardTrackerViewed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshAccounts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshAccounts"), _class.prototype), _class);
export { CheckingBalances as default };